export enum TransactionTypeKeyEnum {
  TypeOfShipping = 'type_of_shipping',
  PurchaseCategory = 'purchase_category',
  BuildType = 'build_type',
  TypeOfSalesTransaction = 'type_of_sales_transaction'
}
